/**
 * Ícones de traço do design (ESPEC.md, viewBox 24): um `path` por traço.
 * Ícone nunca é emoji; emoji é só conteúdo (reações, seletor). Web e
 * celular desenham daqui (SVG no navegador, react-native-svg no app).
 */
export const ICON_PATHS = {
  logo: [
    'M4 5h11a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H9l-4 3v-3.2A3 3 0 0 1 4 13z',
    'M18 9h.5A2.5 2.5 0 0 1 21 11.5v4a2.5 2.5 0 0 1-2 2.45V20l-2.8-2H13',
  ],
  hash: ['M5 9h15', 'M4 15h15', 'M10 3 8 21', 'M16 3l-2 18'],
  cadeado: ['M6 11h12v10H6z', 'M8 11V7a4 4 0 0 1 8 0v4'],
  anuncio: ['M4 10v4h3l8 5V5L7 10z', 'M18.5 9.5a3.5 3.5 0 0 1 0 5'],
  voz: [
    'M11 5 6 9H3v6h3l5 4z',
    'M15.5 8.5a5 5 0 0 1 0 7',
    'M18.5 5.5a9 9 0 0 1 0 13',
  ],
  thread: ['M4 4h16v12H8l-4 4z', 'M8 8h8', 'M8 12h5'],
  forum: ['M4 4h12v9H8l-4 3z', 'M9 16v1h7l4 3V8h-4'],
  'chevron-baixo': ['M6 9l6 6 6-6'],
  'chevron-direita': ['M9 6l6 6-6 6'],
  'chevron-esquerda': ['M15 6l-6 6 6 6'],
  'seta-esquerda': ['M19 12H5', 'M12 19l-7-7 7-7'],
  sino: ['M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9', 'M10 21h4'],
  pin: ['M12 17v5', 'M9 3h6l-1 6 4 4H6l4-4z'],
  pessoas: [
    'M16 19v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1',
    'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z',
    'M22 19v-1a4 4 0 0 0-3-3.9',
    'M16 4.1a3.5 3.5 0 0 1 0 6.8',
  ],
  busca: ['M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14z', 'M20 20l-4-4'],
  'caixa-entrada': ['M3 13h5l2 3h4l2-3h5', 'M5 5h14l2 8v6H3v-6z'],
  mais: ['M12 5v14', 'M5 12h14'],
  sorriso: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
    'M8 14s1.5 2 4 2 4-2 4-2',
    'M9 9.5h.01',
    'M15 9.5h.01',
  ],
  clipe: [
    'M21 11l-9 9a5 5 0 0 1-7-7l9-9a3.5 3.5 0 0 1 5 5l-9 9a2 2 0 0 1-3-3l8-8',
  ],
  engrenagem: [
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
    'M12 2v3',
    'M12 19v3',
    'M4.9 4.9 7 7',
    'M17 17l2.1 2.1',
    'M2 12h3',
    'M19 12h3',
    'M4.9 19.1 7 17',
    'M17 7l2.1-2.1',
  ],
  responder: ['M9 14 4 9l5-5', 'M4 9h10a6 6 0 0 1 6 6v3'],
  encaminhar: ['M15 14l5-5-5-5', 'M20 9H10a6 6 0 0 0-6 6v3'],
  'mais-opcoes': ['M5 12h.01', 'M12 12h.01', 'M19 12h.01'],
  editar: ['M4 20h4L19 9l-4-4L4 16z', 'M14 6l4 4'],
  lixeira: [
    'M4 7h16',
    'M10 11v6',
    'M14 11v6',
    'M6 7l1 13h10l1-13',
    'M9 7V4h6v3',
  ],
  link: [
    'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1',
    'M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  ],
  check: ['M5 12l5 5L20 7'],
  x: ['M6 6l12 12', 'M18 6 6 18'],
  celular: ['M7 2h10v20H7z', 'M11 18h2'],
  escudo: ['M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z'],
  coroa: ['M3 18h18', 'M4 8l4 4 4-7 4 7 4-4-2 10H6z'],
  arquivo: ['M14 3H6v18h12V7z', 'M14 3v4h4'],
  download: ['M12 4v12', 'M7 11l5 5 5-5', 'M5 20h14'],
  arroba: [
    'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
    'M16 12v1.5a2.5 2.5 0 0 0 5 0V12a9 9 0 1 0-3.5 7.1',
  ],
  olho: [
    'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z',
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  ],
  relogio: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 7v5l3 2'],
  imagem: [
    'M3 5h18v14H3z',
    'M8.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
    'M21 15l-5-5L5 19',
  ],
  camera: ['M3 8h4l2-3h6l2 3h4v11H3z', 'M12 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'],
  sair: ['M9 21H5V3h4', 'M16 17l5-5-5-5', 'M21 12H9'],
  enquete: ['M4 20V10', 'M10 20V4', 'M16 20v-7', 'M22 20H2'],
  casa: ['M3 11l9-8 9 8', 'M5 10v10h14V10'],
  alerta: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 8v5', 'M12 16h.01'],
  info: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M12 11v5', 'M12 8h.01'],
  copiar: ['M8 8h12v12H8z', 'M4 16V4h12'],
  enviar: ['M12 19V5', 'M5 12l7-7 7 7'],
  calendario: ['M4 6h16v14H4z', 'M4 10h16', 'M8 3v4', 'M16 3v4'],
  robo: ['M5 8h14v11H5z', 'M12 4v4', 'M9 13h.01', 'M15 13h.01'],
  'enviar-arquivo': [
    'M7 18a4 4 0 0 1-.5-8A6 6 0 0 1 18 9a4.5 4.5 0 0 1-.5 9',
    'M12 12v8',
    'M9 15l3-3 3 3',
  ],
  'usuario-mais': [
    'M15 19v-1a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v1',
    'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z',
    'M19 8v6',
    'M16 11h6',
  ],
  'olho-fechado': [
    'M3 3l18 18',
    'M10.6 10.6a2 2 0 0 0 2.8 2.8',
    'M9.9 5.2A10 10 0 0 1 12 5c6 0 10 7 10 7a17 17 0 0 1-3.2 3.9',
    'M6.6 6.6C3.9 8.3 2 12 2 12s4 7 10 7a9.6 9.6 0 0 0 5.4-1.6',
  ],
  'seta-baixo': ['M12 5v14', 'M19 12l-7 7-7-7'],
  'chevron-cima': ['M6 15l6-6 6 6'],
  usuario: [
    'M20 21v-1a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v1',
    'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  ],
  lista: [
    'M8 6h13',
    'M8 12h13',
    'M8 18h13',
    'M3 6h.01',
    'M3 12h.01',
    'M3 18h.01',
  ],
  filtro: ['M4 5h16l-6 8v6l-4-2v-4z'],
  menu: ['M4 6h16', 'M4 12h16', 'M4 18h16'],
  ponto: ['M12 12h.01'],
  globo: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
    'M3 12h18',
    'M12 3a14 14 0 0 1 0 18',
    'M12 3a14 14 0 0 0 0 18',
  ],
  banir: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z', 'M5.6 5.6l12.8 12.8'],
  menos: ['M5 12h14'],
  'abrir-fora': ['M14 4h6v6', 'M20 4l-9 9', 'M18 14v6H4V6h6'],
  'sino-mudo': [
    'M6 8a6 6 0 0 1 9.5-4.9',
    'M18 11c.4 4.4 3 6 3 6H8',
    'M10 21h4',
    'M3 3l18 18',
    'M6 8c0 4-1 6.5-2 8',
  ],
  local: [
    'M12 21s-7-6.1-7-11a7 7 0 0 1 14 0c0 4.9-7 11-7 11z',
    'M12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  ],
  compartilhar: ['M4 12v7h16v-7', 'M12 3v12', 'M7 8l5-5 5 5'],
  etiqueta: ['M3 12V4h8l9 9-8 8z', 'M7.5 7.5h.01'],
} as const;

export type IconName = keyof typeof ICON_PATHS;

/** Ícones com traço grosso (os de pontos). */
export const THICK_ICONS: ReadonlySet<IconName> = new Set<IconName>([
  'mais-opcoes',
  'ponto',
]);
